@let _icon = icon();
<div class="items-center group/button" [class]="getWrapperClasses()">
  <div
    class="items-center justify-center shrink-0 transition-colors duration-150 ease-in-out"
    [class]="getButtonClasses()"
  >
    <div class="flex items-center text-left gap-1.5" [class]="getInnerClasses()">
      @if (isIconContainerVisible()) {
        <div class="shrink-0">
          @if (loading()) {
            <iac-spinner [size]="spinnerSize()"></iac-spinner>
          } @else {
            @if (_icon) {
              <iac-icon [name]="_icon"></iac-icon>
            }
          }
        </div>
      }
      <div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
